var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bulma-table",
    {
      staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
      attrs: {
        columns: _vm.columns,
        "page-index": _vm.filter.pageIndex,
        "page-size": _vm.filter.pageSize,
        "total-rows": _vm.totalRows,
        "is-loading": _vm.isTableLoading,
        "sort-column": _vm.filter.sortColumn,
        "sort-order": _vm.filter.sortOrder,
        draggable: false,
        "show-pagination": false,
        "is-title-checkable": _vm.editable,
        "title-checkbox-location": "front",
        "is-title-checked": _vm.selectAllChecked,
      },
      on: {
        "title-checkbox-changed": _vm.selectAllItems,
        pageChanged: _vm.onPageChange,
        sort: _vm.sort,
      },
    },
    [
      _vm._l(_vm.activeItems, function (item, index) {
        return _c(
          "tr",
          {
            key: item.quoteItemId,
            class: _vm.isItemDeleted(item) ? "strike-through-line" : "",
          },
          [
            _vm.editable
              ? _c(
                  "td",
                  { staticClass: "has-vertical-middle is-content-width" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-icon p-curve p-smooth m-0 p-bigger",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.isSelected,
                              expression: "item.isSelected",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(item.isSelected)
                              ? _vm._i(item.isSelected, null) > -1
                              : item.isSelected,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = item.isSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      item,
                                      "isSelected",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item,
                                      "isSelected",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item, "isSelected", $$c)
                              }
                            },
                          },
                        }),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon mdi mdi-check" }),
                          _c("label"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "td",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$userInfo.isSupportUser,
                    expression: "$userInfo.isSupportUser",
                  },
                ],
                staticClass:
                  "has-vertical-middle has-text-right linenumber-input",
              },
              [
                item.isAdded
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      class: _vm.defaultRowColourClass(item),
                      attrs: { precision: 0, separator: "" },
                      model: {
                        value: item.lineNumber,
                        callback: function ($$v) {
                          _vm.$set(item, "lineNumber", _vm._n($$v))
                        },
                        expression: "item.lineNumber",
                      },
                    })
                  : _c("span", [_vm._v(_vm._s(item.lineNumber))]),
              ],
              1
            ),
            _c("td", { staticClass: "has-vertical-middle itemno-input" }, [
              item.isAdded
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.itemNo,
                        expression: "item.itemNo",
                      },
                    ],
                    staticClass: "input",
                    class: [
                      _vm.defaultRowColourClass(item),
                      _vm.$v.activeItems.$each[index].itemNo.required
                        ? ""
                        : "is-danger",
                    ],
                    attrs: { placeholder: "Item No." },
                    domProps: { value: item.itemNo },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "itemNo", $event.target.value)
                      },
                    },
                  })
                : _c("span", [_vm._v(_vm._s(item.itemNo))]),
            ]),
            _c("td", { class: ["has-vertical-middle itemdesc-input"] }, [
              item.isAdded
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.itemDesc,
                        expression: "item.itemDesc",
                      },
                    ],
                    staticClass: "input",
                    class: [
                      _vm.defaultRowColourClass(item),
                      _vm.$v.activeItems.$each[index].itemDesc.required
                        ? ""
                        : "is-danger",
                    ],
                    attrs: { placeholder: "Item Description" },
                    domProps: { value: item.itemDesc },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "itemDesc", $event.target.value)
                      },
                    },
                  })
                : _c("span", [_vm._v(_vm._s(item.itemDesc))]),
            ]),
            _c("td", { staticClass: "has-vertical-middle has-text-centered" }, [
              item.isAdded
                ? _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-curve p-smooth m-0 p-bigger",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.blend,
                            expression: "item.blend",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(item.blend)
                            ? _vm._i(item.blend, null) > -1
                            : item.blend,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = item.blend,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(item, "blend", $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item,
                                      "blend",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item, "blend", $$c)
                              }
                            },
                            function ($event) {
                              return _vm.updateBlend(item)
                            },
                          ],
                        },
                      }),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon mdi mdi-check" }),
                        _c("label"),
                      ]),
                    ]
                  )
                : _c("span", { staticClass: "icon has-text-info" }, [
                    _c("i", {
                      staticClass: "mdi mdi-24px",
                      class: [item.blend ? "mdi-check" : ""],
                    }),
                  ]),
            ]),
            _c("td", { staticClass: "has-vertical-middle has-text-centered" }, [
              _vm.editable && !_vm.isItemDeleted(item)
                ? _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-curve p-smooth m-0 p-bigger",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.reportOnly,
                            expression: "item.reportOnly",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(item.reportOnly)
                            ? _vm._i(item.reportOnly, null) > -1
                            : item.reportOnly,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = item.reportOnly,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    item,
                                    "reportOnly",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    item,
                                    "reportOnly",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(item, "reportOnly", $$c)
                            }
                          },
                        },
                      }),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon mdi mdi-check" }),
                        _c("label"),
                      ]),
                    ]
                  )
                : _c("span", { staticClass: "icon has-text-info" }, [
                    _c("i", {
                      staticClass: "mdi mdi-24px",
                      class: [item.reportOnly ? "mdi-check" : ""],
                    }),
                  ]),
            ]),
            _vm.innerValue.quotingMethod === _vm.quotingMethodTypes.Hour
              ? _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-right money-input",
                  },
                  [
                    _vm.editable && !_vm.isItemDeleted(item)
                      ? _c("vue-numeric", {
                          staticClass: "input has-text-right",
                          class: _vm.defaultRowColourClass(item),
                          attrs: { precision: 2 },
                          on: {
                            "value-changed": function ($event) {
                              return _vm.updateValue(index, item)
                            },
                          },
                          model: {
                            value: item.rate,
                            callback: function ($$v) {
                              _vm.$set(item, "rate", _vm._n($$v))
                            },
                            expression: "item.rate",
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.rate,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "td",
              { staticClass: "has-vertical-middle has-text-right money-input" },
              [
                _vm.editable && !_vm.isItemDeleted(item)
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      class: _vm.defaultRowColourClass(item),
                      attrs: { minus: true, precision: 2 },
                      on: {
                        blur: function ($event) {
                          return _vm.updateValue(index, item)
                        },
                      },
                      model: {
                        value: item.hourValue,
                        callback: function ($$v) {
                          _vm.$set(item, "hourValue", _vm._n($$v))
                        },
                        expression: "item.hourValue",
                      },
                    })
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            item.hourValue,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
              ],
              1
            ),
            _c("td", { staticClass: "has-vertical-middle has-text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.$filters.formatNumber(
                    item.dollarValue,
                    _vm.$userInfo.locale
                  )
                )
              ),
            ]),
            _vm.isNtar
              ? _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-right is-content-width",
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            item.loadingPercent,
                            _vm.$userInfo.locale,
                            0
                          )
                        ) + "%"
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c("td", { staticClass: "has-vertical-middle has-text-centered" }, [
              item.presentAs
                ? _c(
                    "div",
                    _vm._l(item.presentAs, function (split) {
                      return _c("div", { key: split.itemType }, [
                        _c(
                          "div",
                          {
                            staticClass: "tags has-addons mb-0 present-as-tags",
                          },
                          [
                            _c(
                              "span",
                              {
                                class: `tag mb-1 is-${split.itemType.toLowerCase()}`,
                              },
                              [_vm._v(_vm._s(split.itemType))]
                            ),
                            _c("span", { staticClass: "tag is-dark mb-1" }, [
                              _vm._v(_vm._s(split.percent) + "%"),
                            ]),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
            _c(
              "td",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$userInfo.isSupportUser,
                    expression: "$userInfo.isSupportUser",
                  },
                ],
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v(_vm._s(item.itemStatus) + " ")]
            ),
            _vm.editable
              ? _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-centered is-content-width",
                  },
                  [
                    _c("div", { staticClass: "icon-container" }, [
                      !_vm.isItemDeleted(item) &&
                      item.isDeleted !== true &&
                      item.deleted !== true
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "button is-danger is-small is-inverted tooltip",
                              attrs: {
                                disabled:
                                  _vm.innerValue.readOnly ||
                                  _vm.isItemDeleted(item),
                                "data-tooltip": "Delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(item, index)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-small" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-delete mdi-24px",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      !_vm.editable
        ? _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c("template", { slot: "footer" }, [
        _c("tr", [
          _c(
            "th",
            {
              staticClass: "left-right-items",
              attrs: { colspan: _vm.totalColSpan },
            },
            [
              _vm.editable
                ? _c("div", { staticClass: "left-item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-info is-rounded is-outlined",
                        attrs: { "data-tooltip": "add item" },
                        on: {
                          click: function ($event) {
                            return _vm.addBlankItem()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", { staticClass: "mdi mdi-plus" }),
                        ]),
                        _c("span", [_vm._v("Add Item")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.activeItems.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "has-text-right has-text-success right-item",
                    },
                    [_vm._v(" Totals ")]
                  )
                : _vm._e(),
            ]
          ),
          _vm.activeItems.length > 0
            ? _c(
                "th",
                {
                  staticClass: "has-text-right has-text-success",
                  class: [
                    _vm.categoryTotal >= 0
                      ? "has-text-success"
                      : "has-text-danger",
                  ],
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatCurrency(
                        _vm.categoryTotal,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]
              )
            : _vm._e(),
          _c("th", { attrs: { colspan: "100%" } }),
        ]),
        _vm.editable
          ? _c("tr", [
              _c(
                "td",
                {
                  staticClass: "has-text-right revalue",
                  attrs: { colspan: _vm.totalColSpan },
                },
                [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small revalue-button",
                        attrs: { "data-tooltip": "add item" },
                        on: {
                          click: function ($event) {
                            return _vm.revalueCategory()
                          },
                        },
                      },
                      [_c("span", [_vm._v("Revalue")])]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-info sign-button",
                        on: {
                          click: function ($event) {
                            return _vm.revalueCategory()
                          },
                        },
                      },
                      [_vm._v(" $ ")]
                    ),
                  ]),
                ]
              ),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "field has-addons" },
                  [
                    _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      attrs: { precision: 2 },
                      model: {
                        value: _vm.revalueValue,
                        callback: function ($$v) {
                          _vm.revalueValue = $$v
                        },
                        expression: "revalueValue",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("td", { attrs: { colspan: "100%" } }),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }